<template>
  <div class="main">
    <!-- 导航组件 -->  
    <NavItem></NavItem> 
    <el-carousel class="h-img" v-if="!userAgent">
      <el-carousel-item v-for="item in images" :key="item">
        <img :src="item" alt="">
      </el-carousel-item>
    </el-carousel>
    <el-carousel class="h-img1" v-else>
      <el-carousel-item v-for="item in images" :key="item">
        <img :src="item" alt="">
      </el-carousel-item>
    </el-carousel>
    <div class="c-content" v-if="!userAgent">
      <div class="c-nav">
        <div  v-for="item of cnavs" :key="item.name">
          <div class="c-img"><img width="100%" height="100%" :src="item.images" alt=""></div>
          <p>{{item.name}}</p>
        </div>
      </div>
      <div class="c-con">
        <div class="c-title center">中国大闸蟹直营连锁品牌</div>
          <div class="c-n-content f-flex">
              <div class="c-n-tit active">
                  <h1>觅蟹台/品好蟹</h1>
                  <p>十七年养蟹<br>成就高品质大闸蟹</p>
              </div>
              <div class="c-n-con">
                  <span>{{experience}}
                    <sup>+</sup>
                  </span>
                  <span>年</span>
                  <p>养蟹体验</p>
              </div>
              <div class="c-n-con">
                  <span>{{citynum}}
                    <sup>+</sup>
                  </span>                
                  <span>座</span>
                  <p>大中城市</p>
              </div>
              <div class="c-n-con">
                  <span>{{company}}
                    <sup>+</sup>
                  </span>               
                  <span>座</span>
                  <p>名企合作</p>
              </div>
          </div>
      </div>
      <div class="c-banner f-flex">
        <div class="c-img" v-for="(item,index) in imgs" :key="index">
          <img :src="item" alt="">
        </div>  
      </div>
      <DockItem></DockItem>
    </div>
    <!-- 移动端 -->
    <div class="c-content1" v-else>
      <div class="c-scroll1">
        <div class="c-nav1">
          <div class="c-item1" v-for="item of cnavs" :key="item.name">
              <div class="c-img1"><img width="100%" height="100%" :src="item.images" alt=""></div>
              <p>{{item.name}}</p>
          </div>
        </div>
      </div>

      <div class="c-con1">
        <div class="c-title1 center">中国大闸蟹直营连锁品牌</div>
          <div class="c-n-content1 f-flex">
              <div class="c-n-tit1 active">
                  <h1>觅蟹台/品好蟹</h1>
                  <p>十七年养蟹<br>成就高品质大闸蟹</p>
              </div>
              <div class="c-n-con1">
                  <span>{{experience}}
                     <sup>+</sup>
                  </span>
                  <span>年</span>
                  <p>养蟹体验</p>
              </div>
              <div class="c-n-con1">
                  <span>{{citynum}}
                    <sup>+</sup>
                  </span>              
                  <span>座</span>
                  <p>大中城市</p>
              </div>
              <div class="c-n-con1">
                  <span>{{company}}
                     <sup>+</sup>
                  </span>     
                  <span>座</span>
                  <p>名企合作</p>
              </div>
          </div>
      </div>
      <div class="c-banner1 f-flex">
        <div class="c-img1" v-for="(item,index) in imgs" :key="index">
          <img :src="item" alt="">
        </div>  
      </div>
      <DockItem></DockItem>
    </div>
    <div class="content" v-if="!userAgent">
      <div class="m-title center">MIXIETAI·MALL</div>
      <div class="s-title center">觅蟹台海鲜·商城</div>
    </div>
    <div class="content1" v-else>
      <div class="m-title1 center">MIXIETAI·MALL</div>
      <div class="s-title1 center">觅蟹台海鲜·商城</div>
    </div>
    <PackageItem></PackageItem>
    <div><img width="100%" src="@/assets/images/banner1.png" alt=""></div>
    <div class="note">
      <div class="n-title f-flex" v-if="!userAgent">
        <h1>关于食蟹的小知识</h1>      
        <img src="@/assets/images/zhishi.png" alt="">
      </div>
      <div class="n-title1 f-flex" v-else>
        <h1>关于食蟹的小知识</h1>
        <img src="@/assets/images/zhishi.png" alt="">
      </div>
      <p>EAT SOME KNOWLEDGE OF CRARS</p>
      <div class="step" v-if="!userAgent">     
            <div class="step-content">
                <div class="item">
                  <img  src="@/assets/images/t-1.png" alt="">
                  <p class="title">1、剪掉大闸蟹的八只脚，包括两只大钳，放凉后其中的肉会自动与蟹壳分开，很容易被捅出甚至是被吸出，因此要留待最后来吃;</p>
                </div>
                <div class="item">
                  <img  src="@/assets/images/t-3.png" alt="">
                  <p class="title">2、将蟹掩(即蟹肚脐部分的一小块盖，公蟹母蟹形状不同)去掉，顺势揭开蟹盖;</p>
                </div>
                <div class="item">
                  <img  src="@/assets/images/t-2.png" alt="">
                  <p class="title">3、先吃蟹盖部分，用小勺把中间的蟹胃部分舀出，轻轻将外面包裹着的蟹黄吮干净。注意，不要吮破中间那个呈三角锥形的蟹胃，应将其丢弃;</p>
                </div>
                <div class="item">
                  <img  src="@/assets/images/t-4.png" alt="">
                  <p class="title">4、吃完蟹盖轮到蟹身，先用剪刀将多余的蟹脚、蟹嘴和蟹肺剪掉;</p>
                </div>
                <div class="item">
                  <img  src="@/assets/images/t-5.png" alt="">
                  <p class="title">5、用勺柄将蟹身中间一个呈六角形的片状物挑出来，那是蟹心部分，丢弃;</p>
                </div>
                <div class="item">
                  <img  src="@/assets/images/t-6.png" alt="">
                  <p class="title">6、用小勺舀点醋淋在蟹身上，然后把蟹身的蟹黄蟹膏吃干净;</p>
                </div>
                <div class="item">
                  <img  src="@/assets/images/s-7.png" alt="">
                  <p class="title">7、把蟹身掰成两半，此时可见成丝状的蟹肉。只要顺着蟹脚来撕，就可以将蟹肉拆出。吃干净的蟹壳是完整呈半透明状的;</p>
                </div>
                <div class="item">
                  <img  src="@/assets/images/s-8.png" alt="">
                  <p class="title">8、用剪刀把蟹腿剪成三截，最末一节蟹脚尖可充当工具。先用蟹脚尖细的那一头把蟹腿中段的肉捅出来，再用蟹脚尖粗的那一头把蟹腿前段的肉捅出来;</p>
                </div>
                <div class="item">
                  <img  src="@/assets/images/s-9.png" alt="">
                  <p class="title">9、将蟹钳分成三段，前两段都可将蟹壳直接剪开，用勺舀出肉。最后的那只钳子，技巧是剪开两边，然后用手往相反的方向掰两只钳脚，钳壳就完整地分开了;</p>
                </div>
                <div class="item">
                  <img  src="@/assets/images/s-10.png" alt="">
                  <p class="title">10、以此吃法吃出来的蟹壳，虽未必能完整地拼回一只蟹的形状来，却也铺陈得条理分明，丝肉不剩。吃完蟹壳洗一洗手，再喝上一杯暖融融的姜茶，一顿饭的时间就吃一只大闸蟹，也觉得酒足饭饱了。</p>
                </div>
            </div>     
      </div>
      <div class="step1" v-else>
            <div class="step-content">
                <div class="item">
                  <img  src="@/assets/images/t-1.png" alt="">
                  <p class="title">1、剪掉大闸蟹的八只脚，包括两只大钳，放凉后其中的肉会自动与蟹壳分开，很容易被捅出甚至是被吸出，因此要留待最后来吃;</p>
                </div>
                <div class="item">
                  <img  src="@/assets/images/t-3.png" alt="">
                  <p class="title">2、将蟹掩(即蟹肚脐部分的一小块盖，公蟹母蟹形状不同)去掉，顺势揭开蟹盖;</p>
                </div>
                <div class="item">
                  <img  src="@/assets/images/t-2.png" alt="">
                  <p class="title">3、先吃蟹盖部分，用小勺把中间的蟹胃部分舀出，轻轻将外面包裹着的蟹黄吮干净。注意，不要吮破中间那个呈三角锥形的蟹胃，应将其丢弃;</p>
                </div>
                <div class="item">
                  <img  src="@/assets/images/t-4.png" alt="">
                  <p class="title">4、吃完蟹盖轮到蟹身，先用剪刀将多余的蟹脚、蟹嘴和蟹肺剪掉;</p>
                </div>
                <div class="item">
                  <img  src="@/assets/images/t-5.png" alt="">
                  <p class="title">5、用勺柄将蟹身中间一个呈六角形的片状物挑出来，那是蟹心部分，丢弃;</p>
                </div>
                <div class="item">
                  <img  src="@/assets/images/t-6.png" alt="">
                  <p class="title">6、用小勺舀点醋淋在蟹身上，然后把蟹身的蟹黄蟹膏吃干净;</p>
                </div>
                <div class="item">
                  <img  src="@/assets/images/s-7.png" alt="">
                  <p class="title">7、把蟹身掰成两半，此时可见成丝状的蟹肉。只要顺着蟹脚来撕，就可以将蟹肉拆出。吃干净的蟹壳是完整呈半透明状的;</p>
                </div>
                <div class="item">
                  <img  src="@/assets/images/s-8.png" alt="">
                  <p class="title">8、用剪刀把蟹腿剪成三截，最末一节蟹脚尖可充当工具。先用蟹脚尖细的那一头把蟹腿中段的肉捅出来，再用蟹脚尖粗的那一头把蟹腿前段的肉捅出来;</p>
                </div>
                <div class="item">
                  <img  src="@/assets/images/s-9.png" alt="">
                  <p class="title">9、将蟹钳分成三段，前两段都可将蟹壳直接剪开，用勺舀出肉。最后的那只钳子，技巧是剪开两边，然后用手往相反的方向掰两只钳脚，钳壳就完整地分开了;</p>
                </div>
                <div class="item">
                  <img  src="@/assets/images/s-10.png" alt="">
                  <p class="title">10、以此吃法吃出来的蟹壳，虽未必能完整地拼回一只蟹的形状来，却也铺陈得条理分明，丝肉不剩。吃完蟹壳洗一洗手，再喝上一杯暖融融的姜茶，一顿饭的时间就吃一只大闸蟹，也觉得酒足饭饱了。</p>
                </div>
            </div> 
      </div>
    </div>
    <KnowItem></KnowItem>
    <ContcatItem></ContcatItem>
  </div>
</template>

<script>
import DockItem from '../components/DockItem'
import PackageItem from '../components/PackageItem'
import ContcatItem from '../components/ContcatItem'
import KnowItem from '../components/KnowItem.vue'
export default {
  name: 'Home',
  data(){
    return{
      images:[],
      experience:"",
      citynum:"",
      company:"",
      crab_supremefive:"",
      eatknowledgeimage:"",
      
      imgs:[require('@/assets/images/zu1.png'),require('@/assets/images/zu2.png'),require('@/assets/images/zu3.png')],
      cnavs:[{'images':require('@/assets/images/lishi.png'),'name':'理事单位'},{'images':require('@/assets/images/chandi.png'),'name':'产地直供'},
      {'images':require('@/assets/images/liansuo.png'),'name':'连锁专卖'},{'images':require('@/assets/images/shunfeng.png'),'name':'顺丰包邮'},
      {'images':require('@/assets/images/jingxuan.png'),'name':'只只精选'},{'images':require('@/assets/images/pinzhi.png'),'name':'品质保障'},
      {'images':require('@/assets/images/changqi.png'),'name':'长期有效'},{'images':require('@/assets/images/fuwu.png'),'name':'全时服务'}]
    }
  },
  components:{
    DockItem,
    PackageItem,
    ContcatItem,
    KnowItem,  
  },
  mounted(){
    this.$http.get('api/index/index').then(res=>{
      this.data=res.data.data
      this.images=this.data.images
      this.experience=this.data.experience,
      this.citynum=this.data.citynum,
      this.company=this.data.company,
      this.crab_supremefive=this.data.crab_supremefive,     
      this.eatknowledgeimage=this.data.eatknowledgeimage
    })
  }
}
</script>
<style>
.el-menu-item.is-active{
  color: #C94032;
}
</style>
<style scoped>


  .main{
    width: 100%;
    position: relative;
    overflow: hidden;
  }
  .c-nav{
      width:80%;
      background:rgba(255,255,255,0.85);
      border-radius:4px;
      display: flex;
      justify-content: space-around;
      opacity: .8;
      text-align: center;
      align-items:center;
      margin: 2% auto;
  }
  .c-nav p{
      font-size:20px;
      margin-top: 3%;
      font-weight:600;
      font-family:Helvetica;
      color:rgba(51,51,51,1);
  }
.c-nav .c-img{
    width: 1.4rem;
    margin: 0 auto;
  }
.c-nav .c-img>img{
    width: 100%;
    height: 100%;
  }
.c-nav>div{
    padding: 0.2rem 0;
    width: 20%;
}
  .c-content{
      width:100%;
      height: 100%;
      background:rgba(64,70,87,1);
      overflow: hidden;  
  }
  .c-content .c-con{
      width: 80%;
      margin: 0 auto;
  }
  .c-title{
      width: 100%;
      height:60px;
      font-family:SourceHanSansCN-Bold,SourceHanSansCN;
      font-weight:bold;
      color:rgba(255,255,255,1);
      line-height:70px;
      font-size: 1rem;
      text-align: center;
  }
  
  .c-n-tit h1{
      font-size:0.8rem;
      font-family:Helvetica;
      color:rgba(255,234,161,1);
      line-height:55px;
      font-weight: normal;
      letter-spacing: .2em;
  }
  .c-n-tit p{
      font-size:0.5rem;
      font-family:Helvetica;
      color:rgba(255,234,161,1);
      line-height:30px;
  }
  .c-n-tit{
      padding: 10px 0;
      text-align: center;
  }
  .c-n-con{
    text-align: center;
  }
  .c-n-con>span:nth-child(1){
      font-size:28px;
      font-family:SourceHanSansCN-Bold,SourceHanSansCN;
      font-weight:bold;
      color:rgba(255,234,161,1);
      line-height:60px;
  }
  .c-n-con>span:nth-child(1)>sup{
      font-size: 14px;
      font-family:Helvetica;
      color:rgba(255,255,255,1);
  }
  .c-n-con>span:nth-of-type(2){
      font-size:20px;
      font-family:HYZhuZiMuTouRenW;
      color:rgba(255,255,255,1);
      line-height:36px;
      margin-left: 20px;
  }
  .c-n-con p{
      font-size:18px;
      font-family:HYZhuZiMuTouRenW;
      color:rgba(255,255,255,1);
      line-height:30px;
  }
  .c-n-content{
    max-width: 1000px;
    width:75%;
    justify-content: space-between;
    padding: 4% 0;
    align-items: center;
    margin: 0 auto;
  }
  /* banner */
  .c-banner{
      width: 80%;
      max-width: 1520px;
      margin: 30px auto;
      justify-content: space-between; 
      position: relative;
  }
  .c-banner>.c-img{
    width:30% ;
    height: 200px;  
  }
  .c-banner>.c-img:nth-child(1){
    margin-top: -60px;
  }
  .c-banner>.c-img>img{
  width:100%; 
}
  .note{
    width: 100%;

  }
  .note h1{
    font-size: 25px;
  }
  .note>p{
    font-size: 8px;
    width:100%;
    text-align: center;
  }
  /* .nav{
    width:100%;
    background:rgba(20,20,20,1);
    align-items: center;
  } */
.n-img1{
    width: 20%;
    text-align: center;
}
.n-img2{
    width: 25%;
}
.n-item{
    font-weight:bold;
    color:rgba(255,255,255,1);
    width: 60%;
    text-align: center;
  }
  .n-item>a{
    font-size: 16px;
    color: white;
    font-family:SourceHanSansCN-Bold,SourceHanSansCN;
    text-align: center;
    margin-right: 5%;
  }
.n-img1 img{
    width: 60%;
    margin-top: 20px;
}
.h-img{
  height: 20%;
  width: 100%;
}
.h-img img{
  height: 100%;
  width: 100%;
  vertical-align: bottom;
}
.h-img1{
  height: 20%;
  width: 100%;
}
.h-img1 img{
  height: 100%;
  width: 100%;
  vertical-align: bottom;
}
.content{
    width:100%;
    background:rgba(255,255,255,1);
    text-align: center;
}
 .m-title{
    width:80%;
    font-size:36px;
    font-family:Helvetica;
    color:rgba(50,50,50,1);
    margin:2% auto 1%;
    font-weight: bold;
}
.s-title{
    width:80%;
    font-size:22px;
    font-family:SourceHanSansCN-Bold,SourceHanSansCN;
    font-weight:bold;
    color:rgba(50,50,50,1);
}
.n-title h1{
  font-size: 35px;
}
.n-title img{
  width: 5%;
}
.n-title{
  width: 80%;
  justify-content: center;
  margin: 0 auto;
  align-items: center;
}
.step{
  background: linear-gradient(#fff,#faf7f1);
  position: relative;
  width: 100%;
  height: 600px;
  margin:0 0 3%;
}
.step .step-content{
  overflow-x: auto;
  overflow-y: hidden;
  width: 80%;
  height: 100%;
  margin: 0 auto;
  display: flex;   
  align-items: center;
}
.step .step-content::-webkit-scrollbar{
  display: block;
}
.step .step-content .item{
  width: 10%;
  height: 50%;
  position: relative;
  font-size: 12px;
  padding: 0 0.5%;  
  margin-right: 5%;
  color: #fff;
  z-index: 100;
  flex-shrink: 0;
  line-height: 0.5rem;
}
.step-content .item img{
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
  border-radius: 10%;
}
.step-content .item .title{
  margin-top: 10%;
  font-size: 14px;
  position: absolute;
  bottom: 3%;
  width: 90%;
  margin: 0 auto;
  text-align: justify;
}

.step-content .item .list{
  margin-top: 5%;
}
.step-content .item:nth-child(odd){
  margin-top: -10%;
}
.step-content .item:nth-child(even){
  margin-top: 10%;
}
/* 移动端 */
.n-title1{
  width: 80%;
  justify-content: center;
  margin: 0 auto;
  align-items: center;
}
.n-title1 h1{
  font-size: 20px;
  margin: 5% 0;
}
.n-title1 img{
  width: 10%;
  margin-left: 2%;
}
.c-content1{
      width:100%;
      height: 100%;
      background:rgba(64,70,87,1);
      position: relative;   
  }
  .c-scroll1{
    overflow-x: auto;
    background:rgba(255,255,255,0.85);
    overflow-y: hidden;
  }
  .c-nav1{
      width: 100%;    
      line-height: 30px;   
      display: flex;
      opacity: .8;
      padding-left: 5%;
  }
  .c-nav1 .c-item1{
    width: 25%;
    flex-shrink: 0;
  }
  .c-nav1 p{
      font-size:12px;
      font-weight:600;
      font-family:Helvetica;
      color:rgba(51,51,51,1);
  }
.c-nav1 .c-img1{
  width: 40px;
  height: 40px;
  margin-top: 5%;
}

.c-img1>img{
  width: 100%;
}
.c-banner1 .c-img1:nth-child(1){
  margin-top: -10px;
}
.c-banner1 .c-img1{
  margin-right: 10px;
}


.c-content1 .c-con1{
      width: 100%;
      margin: 0 auto;
      padding-top: 1px;
  }
  .c-title1{
      width: 100%;
      font-family:SourceHanSansCN-Bold,SourceHanSansCN;
      font-weight:bold;
      color:rgba(255,255,255,1);
      line-height:70px;
      margin-top: 30px;
      font-size: 22px;
      text-align: center;
  }
  
  .c-n-tit1 h1{
      font-size:16px;
      font-family:Helvetica;
      color:rgba(255,234,161,1);
      line-height:30px;
      font-weight: normal;
      letter-spacing: .1em;
  }
  .c-n-tit1 p{
      font-size:14px;
      font-family:Helvetica;
      color:rgba(255,234,161,1);
      line-height:20px;
  }
  .c-n-tit1{
      width: 40%;
      text-align: center;
  }
  .c-n-con1{
    position: relative;
    text-align: center;
    
  }
  .c-n-con1>span:nth-child(1){
      font-size:15px;
      font-family:SourceHanSansCN-Bold,SourceHanSansCN;
      font-weight:bold;
      color:rgba(255,234,161,1);
      line-height:30px;
  }
  .c-n-con1>span:nth-child(2){
      font-size:10px;
      font-family:HYZhuZiMuTouRenW;
      color:rgba(255,255,255,1);
      line-height:36px;
  }
  .c-n-con1 p{
      font-size:12px;
      font-family:HYZhuZiMuTouRenW;
      color:rgba(255,255,255,1);
      line-height:30px;
  }
  .c-n-content1{
    width:100%;
    justify-content: space-between;
  }
  .content1{
    width:100%;
    background:rgba(255,255,255,1);
    margin-bottom: 20px;
    text-align: center;
}
 .m-title1{
    width:80%;
    height:30px;
    font-size:24px;
    font-family:Helvetica;
    color:rgba(50,50,50,1);
    margin-top:20px;
    font-weight: bold;
}
.s-title1{
    width:80%;
    height:10px;
    font-size:18px;
    font-family:SourceHanSansCN-Bold,SourceHanSansCN;
    font-weight:bold;
    color:rgba(50,50,50,1);
}
.c-banner1{
      width: 95%;
      height: 100%;
      margin: 30px auto;
      justify-content: space-between; 
  }


.step1{
  position: relative;
  width: 100%;
  height: 280px;
  margin-bottom: 3%;
  padding: 2% 0;
  background: linear-gradient(#fff,#faf7f1);
}
.step1 .step-content{
    width: 90%;
    height: 100%;
    margin: 0 auto;
    display: flex;
    overflow-x: auto;
    overflow-y: hidden;
    align-items: center;
}
/* ::-webkit-scrollbar{
  display: none;
} */
.step1 .step-content .item{
  width: 30%;
  flex-shrink: 0;
  height: 90%;
  position: relative;
  font-size: 10px;
  margin-right: 5%;
  color: #fff;
  z-index: 100;
  padding: 0 2%;
  line-height: 15px;
}
.step-content1 .item img{
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
  border-radius: 10%;
}
.step-content1 .item p{
  width: 100%;
  white-space: wrap;
}
.step-content1 .item .title{
  margin-top: 10%;
  
}
.step-content1 .item .list{
  margin-top: 5%;
}
.step-content1 .item:nth-child(odd){
  margin-top: -10%;
}
.step-content1 .item:nth-child(even){
  margin-top: 8%;
}



/deep/ .el-tabs__item:hover{
  color: #C94032;
}
.h-img /deep/.el-carousel__container{
  height: 600px !important;
}
.h-img1 /deep/.el-carousel__container{
  height: 160px !important;
}
::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 5px; /*高宽分别对应横竖滚动条的尺寸*/
  height: 5px;
  margin: 0 auto;
  cursor: pointer;
}
::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
}
</style>